/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useMemo, useState } from 'react';

import { OhsFormFieldBaseProps } from 'global-components/form/services/OhsFormModels';
import { OhsHrLookup } from 'human-resource/models/OhsHumanResourceModels';
import OhsContractorLookup from 'contractor/models/OhsContractorLookUp';
import {
  getHrLookupList,
  getContractorLookupList,
  getIncidentLookupList,
} from 'injury-mgmt/OhsInjuryMgmtLookupServices';
import { ModuleType } from 'global-services/constants/OhsObject';
import { parseHrLookupList } from 'human-resource/OhsHumanResourceServices';
import { parseContractorLookupList } from 'contractor/OhsContractorService';
import { IncidentLookUp } from 'incident/IncidentLookUpModel';
import { parseIncidentLookupList } from 'incident/OhsIncidentServices';

import OhsLinkHrContractorField from './OhsLinkHrContractorField';
import OhsCustomLinkField from './OhsCustomLinkField';

interface Props extends OhsFormFieldBaseProps {
  fieldId: string;
  templateId: string;
  recordId: string;
  taskId?: string;
  moduleType: string;
  maxCount?: number;
}

function OhsCusvalLinkValueSysField(props: Props) {
  const [ohsHrLookupList, setOhsHrLookupList] = useState(new Array<OhsHrLookup>());
  const [ohsContractorLookupList, setOhsContractorLookupList] = useState(
    new Array<OhsContractorLookup>()
  );
  const [ohsIncidentLookupList, setOhsIncidentLookupList] = useState<any[]>([]);
  const memoizedModuleType = useMemo(() => props.moduleType, [props.moduleType]);

  const getLookupPayloadId = () => {
    if (props.templateId) {
      return { templateId: props.templateId };
    }
    if (props.recordId) {
      return { recordId: props.recordId };
    }
    if (props.taskId) {
      return { taskId: props.taskId };
    }
    return {};
  };

  const getLookupList = async () => {
    let hrList: OhsHrLookup[] = [];
    let contractorList: OhsContractorLookup[] = [];
    let incidentList: IncidentLookUp[] = [];
    const payloadId = getLookupPayloadId();

    if (props.moduleType === ModuleType.HR && Object.keys(payloadId)?.length) {
      const hrListRes: any = await getHrLookupList({
        forType: ModuleType.Injury,
        sysfieldId: props?.fieldId,
        ...payloadId,
      });
      hrList = parseHrLookupList(hrListRes?.items || []);
    }
    if (props.moduleType === ModuleType.Contractor && Object.keys(payloadId)?.length) {
      const contractorListRes: any = await getContractorLookupList({
        forType: ModuleType.Injury,
        sysfieldId: props?.fieldId,
        ...payloadId,
      });
      contractorList = parseContractorLookupList(contractorListRes || []);
    }
    if (props.moduleType === ModuleType.Incident) {
      const incidentListRes: any = await getIncidentLookupList();
      incidentList = parseIncidentLookupList(incidentListRes || []);
      incidentList = incidentList.map((item) => ({
        ...item,
        _id: item?._id,
        name: item?.reference,
        description: `${item?.category} ${item?.categoryOther ? `(${item?.categoryOther})` : ''}`,
        description2: item?.overview,
        type: item?.type,
      }));
      setOhsIncidentLookupList(incidentList);
    }

    return { hrList, contractorList };
  };

  useEffect(() => {
    const fetchData = async () => {
      const { hrList, contractorList } = await getLookupList();
      setOhsHrLookupList(hrList ?? new Array<OhsHrLookup>());
      setOhsContractorLookupList(contractorList ?? new Array<OhsContractorLookup>());
    };

    fetchData();
  }, [memoizedModuleType]);

  return props.moduleType === ModuleType.Contractor || props.moduleType === ModuleType.HR ? (
    <OhsLinkHrContractorField
      title={props.title}
      id={props.id}
      ohsContractorList={props.moduleType === ModuleType.Contractor ? ohsContractorLookupList : []}
      ohsHrLookupList={props.moduleType === ModuleType.HR ? ohsHrLookupList : []}
      ohsFormSettings={props.ohsFormSettings}
      required={props.required}
      maxCount={props.maxCount}
    />
  ) : (
    <OhsCustomLinkField
      title={props.title}
      id={props.id}
      lookupList={ohsIncidentLookupList}
      ohsFormSettings={props.ohsFormSettings}
      required={props.required}
      maxCount={props.maxCount}
    />
  );
}

OhsCusvalLinkValueSysField.defaultProps = {
  maxCount: undefined,
  taskId: undefined,
};

export default OhsCusvalLinkValueSysField;
